import React from "react";

const CustomCard = ({ start, end, venue, tto_event_meta, eventImage, featuredImage, title, link }) => {
  return (
    <div className="event-card mb-30 d-flex flex-column h-100 overflow-hidden">
      <div className="event-card-img overflow-hidden position-relative square-ratio-img lt-gry-bg">
        <div className="event-dates gld-bg midnight-txt">
          <span className="start-date">{start} </span>
          <span className="end-date">{end}</span>
        </div>
        <a href={link} target="_blank">
          <img
            className="bg-img bg-img-top-center"
            src={eventImage?.["large"] ?? eventImage?.["medium_large"] ?? eventImage?.["medium"]}
            title="Canopy Tempe Happenings"
            alt="Canopy Tempe Happenings"
            loading="lazy"
          />
        </a>
      </div>
      <div className="event-card-content d-flex flex-column h-100 mt-20 position-relative midnight-txt">
        <div className="event-card-content-inner">
          <h3 className="header tiny-header uppercase mb-10">
            <a href={link} target="_blank">
              {title}
            </a>
          </h3>
          <p className="event-venue mb-0 text-50">{venue}</p>
        </div>
        <div className="mt-20 event-card-button hidden-sm-up">
          <a href={link} className="btn button-main midnight-btn" target="_self">
            Event details
            <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 9.2 8.8">
              <defs>
                {/* <style>
      .st0 {
        fill: #161f28;
      }
    </style> */}
              </defs>
              <path
                className="st0"
                d="M9,4L5.2.2c-.2-.2-.6-.2-.8,0s-.2.6,0,.8l2.8,2.8H.6c-.3,0-.6.3-.6.6s.3.6.6.6h6.6l-2.8,2.8c-.2.2-.2.6,0,.8.2.2.6.2.8,0l3.8-3.8c.2-.2.2-.6,0-.8Z"
              ></path>
            </svg>
          </a>
        </div>{" "}
      </div>
    </div>
  );
};

export default CustomCard;
